import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { IoClose } from "react-icons/io5";
import { useState } from 'react';
import SnackBar from '../../General/SnackBar';
import { postShUpdatedAmount } from 'API/CspMapping/api';
import CircularProgress from '@mui/material/CircularProgress';


export default function ApprovalDialog(props) {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)
    const [alertType, setAlertType] = useState("")
    const [alertMessage, setAlertMessage] = useState("")


    const handleErrOpen = (errmessage, alerttype) => {
        setAlertType(alerttype)
        setAlertMessage(errmessage)
        setError(true)

    }

    const handleApprove = () => {
        // console.log("postdata", props);

        let agentdata = Object.values(props.data)

        let postdata = {
            "request_id": props.dsdata.request_id,
            "ds_id": props.dsdata.ds_id,
            "agent_data": agentdata
        }

        postShUpdatedAmount(postdata, setIsLoading, handleErrOpen)

    }



    const handleAlertClose = () => {
        setError(false)
    }


console.log("props at approval",props);

    return (
        <React.Fragment>
            <SnackBar open={error} type={alertType} message={alertMessage} handleClose={handleAlertClose} />
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <Box sx={{ position: "absolute", top: 5, right: 5, fontSize: '25px', cursor: 'pointer' }} onClick={() => props.handleClose()}>
                    <IoClose />
                </Box>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">CSP Name</TableCell>
                                        <TableCell align="center">CSP Code</TableCell>
                                        <TableCell align="center">Bank</TableCell>
                                        <TableCell align="center">Location</TableCell>
                                        <TableCell align="center">Mobile</TableCell>
                                        <TableCell align="center">Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {

                                        sessionStorage.getItem("UserType") === "sh" && props.data ?
                                        Object.entries(props.data).map(([key, value]) => (
                                                <TableRow
                                                    key={key}
                                                >

                                                    <TableCell align="center">{value.aadhaar_name}</TableCell>
                                                    <TableCell align="center">{value.csp_code}</TableCell>
                                                    <TableCell align="center">{value.bank_name}</TableCell>
                                                    <TableCell align="center">{value.retail_district}</TableCell>
                                                    <TableCell align="center">{value.mobile_number}</TableCell>
                                                    <TableCell align="center">{value.sh_amount}</TableCell>

                                                </TableRow>
                                            ))
                                            :
                                            sessionStorage.getItem("UserType") === "rm" && props.dsdata &&props.dsdata.agent_data && props.dsdata.agent_details.map((key, value) => (
                                                <TableRow
                                                    key={key}
                                                >

                                                    <TableCell align="center">{value.aadhaar_name}</TableCell>
                                                    <TableCell align="center">{value.csp_code}</TableCell>
                                                    <TableCell align="center">{value.bank_name}</TableCell>
                                                    <TableCell align="center">{value.retail_district}</TableCell>
                                                    <TableCell align="center">{value.mobile_number}</TableCell>
                                                    <TableCell align="center">{value.sh_amount}</TableCell>

                                                </TableRow>
                                            ))

                                    }


                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid container mt={2} justifyContent='flex-end'>
                            <table>
                                <tr>
                                    <td><Typography variant='h4'>Total</Typography></td>
                                    <td>:</td>
                                    <td><Typography variant='h4'>{props.data ? Object.entries(props.data).reduce((total, [key, value]) => {
                                        if (key) {

                                            return total + (value.sh_amount || 0);
                                        }
                                    }, 0) : null}</Typography></td>
                                </tr>
                            </table>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Stack width="100%" direction="row" alignItems='center' justifyContent="center">
                        {
                            isLoading ?
                                <CircularProgress />
                                :
                                <Button color='success' variant='contained' onClick={() => handleApprove()} autoFocus>
                                    Forward request to RM
                                </Button>
                        }

                    </Stack>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
